import React, { Component } from 'react';
import { connect } from 'react-redux'
import DemandsTable from './DemandsTable';
import demandServices from '../../api/demandsService';
import DemandForm from './DemandForm';

class DemandScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showForm: false,
            showDeleteConfirmation: false,
            loadingData: true
        }

        this.showForm = this.showForm.bind(this);
        this.hideForm = this.hideForm.bind(this);
    }

    showForm() {
        this.setState({
            showForm: true
        });
    }

    hideForm() {
        this.setState({
            showForm: false
        });
    }

    showDeleteConfirmation() {
        this.setState({
            showDeleteConfirmation: true
        });
    }

    hideDeleteConfirmation() {
        this.setState({
            showDeleteConfirmation: false
        });
    }

    render() {
        return (
            <div>
                <DemandsTable demands={this.props.demands}
                    addDemand={this.showForm}
                    deleteDemand={this.showDeleteConfirmation} />
                <DemandForm showModal={this.state.showForm} hideForm={this.hideForm} />
            </div>
        )
    }
}

const mapStateToProps = ({ demandState }) => ({
    demands: demandState.demands
});

export default connect(mapStateToProps)(DemandScreen);